import React, { MouseEventHandler, useEffect, useState } from 'react';
import { useYotpo } from 'components/Yotpo/useYotpo';
import { getStarsAndReviews } from 'components/Yotpo/helpers';
import { getYotpoApiKey } from 'helpers/env';
import { Rating } from '../../../types/Product';
import { YotpoStarsUI } from 'components/Yotpo/YotpoStars/YotpoStarsUI';
import cx from 'classix';

type YotpoStarsProps = {
  rating?: Rating;
  StarComponent?: React.FC<{ type: string }>;
};

const Star: React.FC<{ type: string }> = ({ type }: { type: string }) =>
  <span className={cx(`yotpo-icon yotpo-icon-${type}`, 'rating-star', 'pull-left')} />;

const apiKey = getYotpoApiKey();

const YotpoStars: React.FC<YotpoStarsProps> = ({
  rating,
  StarComponent = Star
}: YotpoStarsProps) => {
  useYotpo(apiKey);

  const { score = 0, totalReviews = 0 } = rating;
  const { stars } = getStarsAndReviews(rating, StarComponent);

  const [anchorTarget, setAnchorTarget] = useState(null);

  const handleClick: MouseEventHandler<HTMLAnchorElement> = event => {
    event.preventDefault();
    anchorTarget.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    setAnchorTarget(document.getElementById('yotpo-reviews-anchor'));
  }, []);

  return (
    <YotpoStarsUI
      stars={stars}
      score={score}
      totalReviews={totalReviews}
      handleClick={handleClick}
    />
  );
};

export default YotpoStars;
